import React, { forwardRef, useRef } from "react";
import { Label } from "../Label";
import Error from "./Error.styles";
import Root from "./Root.styles";
import TextareaPrimitive from "./Textarea.styles";
import { useAutoResize } from "./useAutoResize";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  /** Optional label text for the textarea */
  label?: React.ReactNode;
  /** Error message to display beneath the textarea */
  error?: React.ReactNode;
  /** Whether the input has valid content */
  isValid?: boolean;
  /** Height of the textarea in pixels */
  height?: number;
}

export const Textarea = forwardRef(
  (
    {
      className,
      error,
      label,
      required,
      id,
      disabled,
      isValid = true,
      height,
      ...props
    }: TextareaProps,
    ref?: React.ForwardedRef<HTMLTextAreaElement>
  ) => {

    const textAreaRef = useAutoResize(ref);

    return (
      <Root title="text-area-title" aria-label={id} className={className}>
        {label && (
          <Label
            required={required}
            htmlFor={id}
            disabled={disabled}
            isValid={isValid}
          >
            {label}
          </Label>
        )}
        <TextareaPrimitive
          height={height}
          id={id}
          isValid={isValid}
          required={required}
          {...props}
          ref={textAreaRef}
        />
        {error && <Error>{error}</Error>}
      </Root>
    )
  }
);

Textarea.displayName = "Textarea";
